import { LoginModel } from '../../model/login.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { ForgotPasswordModel } from 'src/app/model/forgot-password.model';

export const SubmitRequestAction = createAction('[Forgot password View] forgot',
  props<{ payload: ForgotPasswordModel }>());

export const SubmitResponseAction = createAction('[Forgot password View] forgot response');
